import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  actionButton: {
    float: 'right',
    marginLeft: pxToRem(10),
  },
});
